import Yup from '../yup';

const yourRole = {
  seeking: Yup.string()
    .equals(
      ['appl'],
      'You cannot use this form if you are the respondent to an intervention order.'
    )
    .required('Please select your role'),
};

export default yourRole;
